import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { AppSelectors } from '../../../../../selectors';
import PremiumCompare from '../../../../PremiumCompare';
import PremiumFeatureSummary from '../../../../PremiumFeatureSummary';

const FreemiumPay = () => {
  const premiumCompareRef = useRef<HTMLDivElement>(null);
  const isScreenDesktop = useSelector((state) => AppSelectors.makeIsScreenXlGTE(state));

  return (
    <div data-testid="FreemiumPay">
      <PremiumFeatureSummary premiumCompareRef={premiumCompareRef} hideCompareAndLearnMore={!isScreenDesktop} />
      <div ref={premiumCompareRef}>
        <PremiumCompare />
      </div>
    </div>
  );
};

export default FreemiumPay;
